import script from "./AlertCell.vue?vue&type=script&setup=true&lang=ts"
export * from "./AlertCell.vue?vue&type=script&setup=true&lang=ts"

import "./AlertCell.vue?vue&type=style&index=0&id=8c86b04a&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8c86b04a"]])

export default __exports__